import classNames from "classnames";
import { RichParagraphs } from "~/components/RichParagraphs";
import { StrapiStore } from "~/shared-types";

type StoreDetailsProps = {
  store: StrapiStore;
  className?: string;
};

function StoreDetails({ store, className }: StoreDetailsProps) {
  return (
    <div className={classNames("md:pl-0", className)}>
      <h2 className="text-4xl md:text-4xl text-black mb-5">
        {store?.attributes.name}
      </h2>
      <div className="line-clamp-5 mb-5">
        <RichParagraphs
          className="text-secondary-800"
          text={store?.attributes.introduction}
        />
      </div>
    </div>
  );
}

export { StoreDetails };
